<template>

    <section>

        <!-- ここから -->

        <div class="cropper_component-control">
            <div class="title"><span>画像をトリミングする</span></div>
            <button class="btn_svg-icon">
                <SvgIconBack />
            </button>
            <button type="button" class="btn_link md_icon-text _white">
                <div class="inner">
                    <span><div class="icon"><SvgIconCheck /></div>決定</span>
                </div>
            </button>
        </div>

        <!-- ここまで -->

    </section>

</template>

<script>
    //Svg
    import SvgIconBack from '@/components/EndUser/svg/SvgIconBack'
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'

    export default {
        components: {
            //Svg
            SvgIconBack,
            SvgIconCheck,
        },
    }
</script>
